import "./EditInstructionWithContacts.html";

import "../EditInstructionRows/EditInstructionRowsComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditInstructionRowsComponentController from "./EditInstructionWithContactsComponentController";

export default class EditInstructionWithContactsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            heading: "<",
            instruction: "=",
            site: "<",
        };
        this.controller = EditInstructionRowsComponentController;
        this.templateUrl = "/App/Components/Forms/EditInstructionWithContacts/EditInstructionWithContacts.html";
    }
}

module("mmManagePortal").component("irEditInstructionWithContacts", new EditInstructionWithContactsComponent());
